/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */

import * as coreHttp from "@azure/core-http";
import * as Models from "../models";
import * as Mappers from "../models/familyPhoneVerificationMappers";
import * as Parameters from "../models/parameters";
import { MicrosoftConsumerSecurityClientContext } from "../microsoftConsumerSecurityClientContext";

/** Class representing a FamilyPhoneVerification. */
export class FamilyPhoneVerification {
  private readonly client: MicrosoftConsumerSecurityClientContext;

  /**
   * Create a FamilyPhoneVerification.
   * @param {MicrosoftConsumerSecurityClientContext} client Reference to the service client.
   */
  constructor(client: MicrosoftConsumerSecurityClientContext) {
    this.client = client;
  }

  /**
   * Calls the VerificationClient API to generate a security code and sends it to the phone number.
   * @summary Generates a security code that is sent to the phone number.
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  generateCode(csid: string, options?: Models.FamilyPhoneVerificationGenerateCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  generateCode(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  generateCode(csid: string, options: Models.FamilyPhoneVerificationGenerateCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  generateCode(csid: string, options?: Models.FamilyPhoneVerificationGenerateCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      generateCodeOperationSpec,
      callback);
  }

  /**
   * Calls the VerificationClient API to verify the security code of the phone number.
   * @summary Verifies the security code for the phone number.
   * @param csid
   * @param [options] The optional parameters
   * @returns Promise<coreHttp.RestResponse>
   */
  verifyCode(csid: string, options?: Models.FamilyPhoneVerificationVerifyCodeOptionalParams): Promise<coreHttp.RestResponse>;
  /**
   * @param csid
   * @param callback The callback
   */
  verifyCode(csid: string, callback: coreHttp.ServiceCallback<void>): void;
  /**
   * @param csid
   * @param options The optional parameters
   * @param callback The callback
   */
  verifyCode(csid: string, options: Models.FamilyPhoneVerificationVerifyCodeOptionalParams, callback: coreHttp.ServiceCallback<void>): void;
  verifyCode(csid: string, options?: Models.FamilyPhoneVerificationVerifyCodeOptionalParams | coreHttp.ServiceCallback<void>, callback?: coreHttp.ServiceCallback<void>): Promise<coreHttp.RestResponse> {
    return this.client.sendOperationRequest(
      {
        csid,
        options
      },
      verifyCodeOperationSpec,
      callback);
  }
}

// Operation Specifications
const serializer = new coreHttp.Serializer(Mappers);
const generateCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/phone/code",
  urlParameters: [
    Parameters.csid
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PhoneGenerateCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};

const verifyCodeOperationSpec: coreHttp.OperationSpec = {
  httpMethod: "POST",
  path: "api/v1/IdentityTheftMonitoring/family/members/{csid}/phone/verify",
  urlParameters: [
    Parameters.csid
  ],
  queryParameters: [
    Parameters.updateExternal
  ],
  requestBody: {
    parameterPath: [
      "options",
      "body"
    ],
    mapper: Mappers.PhoneVerificationCodeRequest
  },
  contentType: "application/json-patch+json; charset=utf-8",
  responses: {
    200: {},
    default: {
      bodyMapper: Mappers.ConsumerSecurityErrorResponse
    }
  },
  serializer
};
